module.exports = require('text!edge/endorsement/common/views/contact-underwriter.html')


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/plugin?gatewayendorsement!./common/js/src/edge/endorsement/common/views/contact-agent.html
// module id = 499
// module chunks = 0